<template>
  <section class="pv-32 ph-16">
    <bl-text-av class="mb-24" tag="h2" variation="heading-24" weight="bold" align="center">
      {{ $options.articleList.title }}
    </bl-text-av>

    <div v-if="mutualFundArticles">
      <div v-for="(article, index) in mutualFundArticles" :key="index" :class="{ 'mt-24': index !== 0 }">
        <a :href="buildArticleUrl(article)" target="_blank">
          <div style="overflow: hidden; height: 100px">
            <img class="mb-12" :src="article.thumbnail_url" :alt="article.title" style="width: 100%; height: auto" />
          </div>

          <bl-text-av class="mb-4" variation="caption-10" color="subdued">{{
            article.posting_date | formatDate
          }}</bl-text-av>
          <bl-text-av tag="h3" variation="body-14" :ellipsis="2">{{ article.title }}</bl-text-av>
        </a>
      </div>

      <bl-button-av class="mt-32" variation="outline" fullwidth :href="$options.articleList.otherArticle.url">
        {{ $options.articleList.otherArticle.text }}
      </bl-button-av>
    </div>
  </section>
</template>

<script>
/* istanbul ignore file */
import { ArticleList as articleList } from 'shared/modules/seo/Homepage';
import BlTextAv from '@bukalapak/bazaar-mweb-2/dist/components/BlTextAv';
import BlButtonAv from '@bukalapak/bazaar-mweb-2/dist/components/BlButtonAv';
import dayjs from 'dayjs';

export default {
  name: 'ArticleList',

  articleList,

  filters: {
    formatDate(val) {
      return dayjs(val).format('DD MMMM YYYY');
    },
  },

  components: {
    BlTextAv,
    BlButtonAv,
  },

  computed: {
    mutualFundArticles() {
      return this.$store.state.server.mutualFundArticles;
    },

    isSSR() {
      return this.$root.isSSR;
    },
  },

  created() {
    if (!this.$root.isSSR && !this.mutualFundArticles) {
      // Ignore error because
      this.$store.dispatch('server/retrieveMutualFundArticles');
    }
  },

  methods: {
    buildArticleUrl(article) {
      const category = article.categories[0];
      return `${process.env.BUKAREVIEW_HOST}/${category.slug}/${article.slug}-${article.id}`;
    },
  },
};
</script>
